<template>
    <ul class="filter-calendar " :style="`top:${top}px`">
        <li v-for="(item, index) in list" :key="index">
            <button @click="goToSlide(index)" :ref="'monthBtn_' + index" class="h-100">
                <figure class="m-0 h-100">
                    <img :src="item.icon" :alt="item.title">
                    <figcaption class="figcaption" :class="{ 'activeTab': index == activeIndex }">
                        {{ item.title }}
                    </figcaption>
                </figure>
            </button>
        </li>

    </ul>
</template>
<script>
export default {
    props: {
        list: Array,
        currentMonthIndex: Number
    },
    data() {
        return {
            top: 0,
            activeIndex: 0,
        }
    },
    // watch: {
    //     currentMonthIndex(newVal) {
    //         this.$nextTick(() => {
    //             this.scrollToTab()
    //             this.scrollMonthIntoView(newVal)
    //         });
    //     },
    // },
    watch: {
        currentMonth(newMonth) {
            this.scrollMonthIntoView(newMonth)
            this.activeIndex = newMonth
        },
        currentMonthIndex(newVal) {
            // console.log(newVal, "sssssssssss");

            this.scrollMonthIntoView(newVal)
            this.activeIndex = newVal
        },
    },
    computed: {


        currentMonth() {
            // console.log(this.$store.getters["front/getCurrentMonth"], "11111111111111111");
            // this.activeIndex = this.$store.getters["front/getCurrentMonth"]
            return this.$store.getters["front/getCurrentMonth"];
        },

    },
    mounted() {



        this.$nextTick(() => {

            this.scrollMonthIntoView(this.currentMonth)
            this.activeIndex = this.currentMonth
            // this.$emit("changeSlide", this.currentMonth)
            // console.log(this.currentMonth, "this.currentMonth");
            // console.log(this.activeIndex, "this.currentMonth");

        })
        window.addEventListener('scroll', this.topFixed);

    },
    methods: {
        scrollMonthIntoView(index) {
            this.$nextTick(() => {
                const btnRefName = "monthBtn_" + index;
                const btn = this.$refs[btnRefName]; // اینجا $refs آرایه است و باید با نام دقیق صدا زده شود
                const container = document.querySelector(".filter-calendar");

                // چک می‌کنیم که هم دکمه و هم کانتینر پیدا شده باشند
                if (btn && container && btn[0]) { // دکمه پیدا شده (ممکن است آرایه باشد)
                    const actualBtn = btn[0]; // اگر ref آرایه‌ای برگرداند، اولین المنت را می‌گیریم

                    const btnLeft = actualBtn.offsetLeft;
                    const btnWidth = actualBtn.offsetWidth;
                    const containerWidth = container.offsetWidth;

                    // محاسبه موقعیت اسکرول: وسط کانتینر + موقعیت دکمه
                    const scrollPosition = btnLeft - (containerWidth / 2) + (btnWidth / 2);

                    container.scrollTo({
                        left: scrollPosition,
                        behavior: "smooth"
                    });
                } else {
                    // اگر دکمه پیدا نشد، ممکن است هنوز رندر نشده باشد یا ایندکس اشتباه باشد
                    // console.warn(`Button with ref "${btnRefName}" not found or not rendered yet.`);
                }
            });
        },
        scrollToTab() {
            const element = document.querySelector('#calendarSlider')
            const filter = document.querySelector('.filter-calendar')
            const fixedHeader = document.querySelector('#fixedHeaderSection')

            if (element && filter) {
                const filterHeight = filter.offsetHeight
                const fixedHeaderHeight = fixedHeader.offsetHeight
                // console.log(filterHeight, "filterHeight");
                // console.log(fixedHeaderHeight, "fixedHeaderHeight");

                const y = element.getBoundingClientRect().top + window.pageYOffset - filterHeight - fixedHeaderHeight

                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                })
            }
        },
        goToSlide(index) {
            this.$emit("changeSlide", index)
            this.scrollToTab()
            this.activeIndex = index
            this.scrollMonthIntoView(index)
        },
        topFixed() {
            const fixedHeader = document.querySelector('#fixedHeaderSection')
            this.top = fixedHeader.getBoundingClientRect().height;

        },
    },

    beforeDestroy() {
        window.removeEventListener("'scroll'", this.topFixed);
    },
}
</script>
<style scoped>
img {
    width: 100%;
}



.filter-calendar {
    list-style-type: none;
    display: flex;
    align-items: stretch;
    gap: 16px;
    overflow: auto;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 0;
    position: sticky;

    z-index: 100;
    padding-block: 10px;
    background-color: white;
}

.filter-calendar button {
    background-color: unset;
}

.filter-calendar button img {
    min-width: 80px;
}

.filter-calendar figure {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.figcaption {
    font-size: 14px;
    margin-top: 10px;
    font-weight: 800;
    border: 3px dashed transparent;
}

.figcaption.activeTab {
    color: var(--color-theme);
    border-radius: 20px;
    border: 3px dashed var(--color-theme);
}

@media only screen and (max-width:640px) {

    .filter-calendar {
        padding-block: 6px;
        margin-top: 10px;

    }

    .figcaption {
        font-size: 13px;
    }


}
</style>